<template>
    <v-btn prepend-icon="mdi-progress-check"
           class="mr-1"
           v-if="job.status < $constants.jobs.JOBSTAT_COMP"
           @click="showComplete = true"
           variant="flat"
           :loading="loading"
           color="grey-lighten-2">
        Complete Job
    </v-btn>
    <v-dialog v-model="showComplete"
              fullscreen
              persistent
              :scrim="false">
        <v-card>
            <v-toolbar dark
                       color="primary">
                <v-toolbar-title><v-icon icon="mdi-progress-check"></v-icon> Complete Job</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon
                       dark
                       @click="showComplete = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <p>This will mark the job as complete and skip all other stages - including invoicing.</p>
                <b>PLEASE ONLY USE IF JOB DOES NOT NEED TO BE PROCESSED IN SYSTEM.</b>
                <v-text-field v-model="reason"
                              :rules="[$rules.required]"
                              label="Reason"></v-text-field>
                <small>Please provide a reason for completing this job.</small>
            </v-card-text>
            <v-card-actions>
                <v-btn :loading="saving"
                       color="primary"
                       :disabled="reason.length == 0"
                       prepend-icon="mdi-floppy"
                       @click="confirmComplete"
                       dark>
                    COMPLETE JOB
                </v-btn>
                <v-btn dark @click="showComplete = false" :disabled="saving">
                    CANCEL
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped>

</style>
<script>
    function initialState() {
        return {
            loading: false,
            showComplete: false,
            reason: ''
        };
    }
    import { mapActions } from "vuex";
    export default {
        name: "JobComplete",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            job: Object
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "reloadEntities",
                "loadEntityRecord"
            ]),
            confirmComplete() {
                this.$confirm(
                    {
                        message: 'This will mark the job as completed. Please ensure this is invoiced in Xero? THIS CANNOT BE UNDONE.',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.loading = true;
                                this.$api.post('/jobs/markcompleted/?id=' + this.job.id +'&reason='+this.reason)
                                    .then(res => {
                                        this.loading = false;
                                        this.loadEntityRecord({ entityId: this.job.id, entity: this.$constants.entities.Job });
                                        this.showComplete = false;
                                    }).catch(error => {
                                        this.showErrorSnack('We ran into an issue');
                                        console.log(error)
                                        this.loading = false;
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
        }
    };
</script>